var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLock = function SvgIconLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.625 4.875V7.25H4.5A1.75 1.75 0 0 0 2.75 9v10.5c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75V9a1.75 1.75 0 0 0-1.75-1.75h-3.125V4.875a4.375 4.375 0 1 0-8.75 0M12 2.5a2.375 2.375 0 0 0-2.375 2.375V7.25h4.75V4.875A2.375 2.375 0 0 0 12 2.5M4.75 9.25h14.5v10H4.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconLock;